import $axios from "@/service/httpServer";

export const getSchedule = (p) =>
  $axios.get("/tony-teaching/readingPlan/query-page", p);

export const getCourse = (p) =>
  $axios.get("/tony-teaching/course_ware/queryByPage", p);

export const getLoginCode = (p) => $axios.get("/tony-common/check-code", p);

export const login = (p) => $axios.get("/tony-admin/user/login", p);

/**
 * 根据key获取图片地址
 *  @param {String} objectKey
 */
export const getFileTempUrlByKeyApi = function (objectKey) {
  return $axios.get('/tony-common/fileDownload/getFileTempUrlByKey', { objectKey })
}

/**
 * 根据stage获取课程资源
 * @param {Object} params
 * @param {String} params.planId
 * @param {Number} params.pageIndex
 * @param {Number} params.pageSize
 */
export const getCourseResourcesByStage = (params) =>
  $axios.get('/tony-teaching/courseResource/queryByStage', params);

/**
 * 根据stage获取课程资源
 * @param {Object} params
 * @param {String} params.planId
 */
export const getCourseResourcesByPlan = (params) =>
  $axios.get('/tony-teaching/courseResource/queryByPlan', params);
